<template>
   <div class="box">
        <h1 contenteditable="true">丝语智训智能互动教学辅助平台</h1>
    </div>
</template>

<script>

export default {
    name: 'Title',
    components: {
    }
}
</script>

<style lang="less" scoped>
.box {
    width: 100%;
    /* 投影效果 */
    -webkit-box-reflect: below 1px linear-gradient(transparent, rgba(0, 0, 0, 0.2));
}

h1 {
    color: #fff;
    font-size: 60pt;
    /* 字间距 */
    letter-spacing: 15px;
    /* 转大写 */
    text-transform: uppercase;
    text-align: center;
    line-height: 76px;
    outline: none;
    /* 自定义属性 --c,可通过 var 函数对其调用 */
    --c: lightseagreen;
    /* 调用自定义属性--c，设置文字阴影（发光效果） */
    text-shadow: 0 0 10px var(--c),
        0 0 20px var(--c),
        0 0 40px var(--c),
        0 0 80px var(--c),
        0 0 160px var(--c);
    /* 执行动画：动画名 时长 线性的 无限次播放 */
    animation: animate 5s linear infinite;
}

/* 定义动画 */
@keyframes animate {
    to {
        /* 色相旋转过滤镜（设置度数可改变颜色） */
        filter: hue-rotate(360deg);
    }
}
</style>